/**
 * Reducer to handle generic data loading and CRUD operation
 *
 */

import produce from "immer";

import {
  RUN_EFFECT_V3,
  RUN_EFFECT_V3_SUCCESS,
  UNLOAD_EFFECT_V3,
  LOAD_VIEW3_SUCCESS
} from "../constants";

const initialState = {
  effects: {}, // holds dataset
  effectsLoading: {} ,// true if a DATASET loading operation in ongoing,
};

const dataReducer = produce((draft, action) => {

  switch (action.type) {
    
    case RUN_EFFECT_V3: {
      draft.effectsLoading[action.effectId] = true;
      break;
    }

    case RUN_EFFECT_V3_SUCCESS: {
      draft.effects[action.effectId] = action.data;
      delete draft.effectsLoading[action.effectId];
      break;
    }
    case UNLOAD_EFFECT_V3: {
      delete draft.effects[action.effectId];
      break;
    }
    case LOAD_VIEW3_SUCCESS: {
      draft.effects['view'] = action.effects
      break;
    }
    default:
      break;
  }
}, initialState);

export default dataReducer;

export const getEffects = state => {
  return state.effects;
};

export const getEffectsLoading = state => {
  return state.effectsLoading;
};

